<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Вы уверены, что хотите изменить товарные категории? </div>
				<div class="popup__close" @click="$emit('close')"></div> 
			</div>
			<div class="popup__description">При удалении текущих выбранных товарных категорий, вы потеряете доступ к существующим тендерам. Изменение товарных категорий доступно раз в сутки.</div>
			<hr/>
			<div class="popup__content">
				<div class="popup__btns">
					<button class="btn btn--color" @click="handleSubmit">Да</button>
					<button class="btn btn--border" @click="$emit('close')">Нет</button>
				</div>
			</div>
		</div>
	</div>
    
</template>
<script>


export default {
	name: 'EditCategoriesConfirmPopup',
	emits: ['close', 'confirmChange'],

	methods: {
		async handleSubmit() {
			this.$emit('confirmChange')
			this.$emit('close')
		},
	},

}
</script>
